import React from 'react'
import { Link } from 'react-router'

export default{
    logintoken: 'Enviar correo',
    ready: 'Correo enviado',
    LoginToken: () => (
      <div>
        {/* <Link to='/logintoken'>Para iniciar sesión con correo</Link>
        <br/> */}
        <Link to='/logintoken'>Inicia sesión por correo</Link>
      </div>
      )
}


// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/logintoken/es.js